<template>
  <VContainer fluid class="primary fill-height">
    <VRow>
      <VCol cols="12">
        <vue-calendly url="https://calendly.com/alvaro-reportlake" :height="900" />
      </VCol>
    </VRow>
  </VContainer>
</template>
